export const ELECTRONIC_ITEM_DEFINITIONS = Object.freeze([
    {
        id: "component.copper_wire",
        name: "COPPER WIRE",
        description: "Insulated copper wire in short usable lengths.",
        category: "COMPONENT",
        tags: ["METAL", "ELECTRONIC", "SALVAGE"],
        stackLimit: 40,
        unitMassGrams: 28,
        volumeMl: 25,
        longestDimensionMm: 80,
        iconKey: "wire",
        worldAssetId: "pickup_bundle",
        scarcity: "COMMON",
        sortOrder: 50,
    },
    {
        id: "component.bolts",
        name: "BOLTS",
        description: "Mixed machine bolts with serviceable threads.",
        category: "COMPONENT",
        tags: ["METAL", "FASTENER", "SALVAGE"],
        stackLimit: 50,
        unitMassGrams: 18,
        volumeMl: 4,
        longestDimensionMm: 45,
        iconKey: "fastener",
        worldAssetId: "scrap_bundle",
        scarcity: "COMMON",
        sortOrder: 51,
    },
    {
        id: "component.screws",
        name: "SCREWS",
        description: "Assorted steel screws kept in a small pouch.",
        category: "COMPONENT",
        tags: ["METAL", "FASTENER", "SALVAGE"],
        stackLimit: 50,
        unitMassGrams: 7,
        volumeMl: 2,
        longestDimensionMm: 35,
        iconKey: "fastener",
        worldAssetId: "scrap_bundle",
        scarcity: "COMMON",
        sortOrder: 52,
    },
    {
        id: "component.small_spring",
        name: "SMALL SPRING",
        description: "A compact steel spring with little deformation.",
        category: "COMPONENT",
        tags: ["METAL", "SALVAGE"],
        stackLimit: 30,
        unitMassGrams: 12,
        volumeMl: 8,
        longestDimensionMm: 40,
        iconKey: "component",
        worldAssetId: "pickup_bundle",
        scarcity: "COMMON",
        sortOrder: 53,
    },
    {
        id: "component.fuse_small",
        name: "SMALL FUSE",
        description: "A low-current cartridge fuse with intact contacts.",
        category: "COMPONENT",
        tags: ["ELECTRONIC", "METAL"],
        stackLimit: 20,
        unitMassGrams: 8,
        volumeMl: 3,
        longestDimensionMm: 30,
        iconKey: "component",
        worldAssetId: "pickup_bundle",
        scarcity: "UNCOMMON",
        sortOrder: 54,
    },
    {
        id: "component.relay_small",
        name: "SMALL RELAY",
        description: "A sealed electromechanical switching relay.",
        category: "COMPONENT",
        tags: ["ELECTRONIC", "METAL"],
        stackLimit: 12,
        unitMassGrams: 32,
        volumeMl: 20,
        longestDimensionMm: 35,
        iconKey: "component",
        worldAssetId: "pickup_bundle",
        scarcity: "UNCOMMON",
        sortOrder: 55,
    },
    {
        id: "electronics.battery_aa",
        battery: { format: "AA", capacityWh: 2.5 },
        name: "AA BATTERY",
        description: "A standard alkaline cell with an intact casing.",
        category: "ELECTRONICS",
        tags: ["ELECTRONIC", "BATTERY", "METAL"],
        stackLimit: 1,
        unitMassGrams: 24,
        volumeMl: 9,
        longestDimensionMm: 51,
        iconKey: "battery",
        worldAssetId: "battery_bundle",
        scarcity: "COMMON",
        sortOrder: 60,
    },
    {
        id: "electronics.battery_18650",
        battery: { format: "18650", capacityWh: 9 },
        name: "18650 CELL",
        description: "A rechargeable lithium cell of uncertain charge.",
        category: "ELECTRONICS",
        tags: ["ELECTRONIC", "BATTERY", "METAL"],
        stackLimit: 1,
        unitMassGrams: 48,
        volumeMl: 18,
        longestDimensionMm: 65,
        iconKey: "battery",
        worldAssetId: "battery_bundle",
        scarcity: "SCARCE",
        sortOrder: 61,
    },
    {
        id: "electronics.circuit_board_small",
        name: "SMALL CIRCUIT BOARD",
        shortName: "CIRCUIT BOARD",
        description: "A compact populated board recovered from equipment.",
        category: "ELECTRONICS",
        tags: ["ELECTRONIC", "METAL", "SALVAGE"],
        stackLimit: 10,
        unitMassGrams: 85,
        volumeMl: 75,
        longestDimensionMm: 100,
        iconKey: "circuit",
        worldAssetId: "pickup_bundle",
        scarcity: "UNCOMMON",
        sortOrder: 62,
    },
    {
        id: "electronics.usb_cable",
        name: "USB CABLE",
        description: "A short data cable with both connectors present.",
        category: "ELECTRONICS",
        tags: ["ELECTRONIC", "METAL", "PLASTIC"],
        stackLimit: 8,
        unitMassGrams: 42,
        volumeMl: 55,
        longestDimensionMm: 100,
        iconKey: "cable",
        worldAssetId: "pickup_bundle",
        scarcity: "COMMON",
        sortOrder: 63,
    },
    {
        id: "electronics.broken_phone",
        name: "BROKEN PHONE",
        description: "A damaged handset useful only for its components.",
        category: "ELECTRONICS",
        tags: ["ELECTRONIC", "METAL", "PLASTIC", "SALVAGE"],
        stackLimit: 4,
        unitMassGrams: 190,
        volumeMl: 115,
        longestDimensionMm: 155,
        iconKey: "phone",
        worldAssetId: "pickup_bundle",
        scarcity: "UNCOMMON",
        sortOrder: 64,
    },
]);
